import React from 'react';

import { GlobalLiveMessage } from '@lumapps/aria-live/components/GlobalLiveMessage';
import { get } from '@lumapps/constants';
import { ConnectedPageTransition } from '@lumapps/router/components/PageTransition';

import { InnerShellProps, InnerShell } from '../InnerShell';
import { Shell, ShellProps } from '../Shell';

export type AppShellProps = ShellProps & InnerShellProps;

const { isDev } = get();

/**
 * Component that wraps any application with necessary providers and configurations.
 * This is a higher-level component that combines the `Shell` and `InnerShell` components
 * to provide a complete application shell.
 * It includes routing, translations, notifications, and advanced debug info.
 * @param AppShellProps
 * @returns AppShell
 */
export const AppShell: React.FC<AppShellProps> = ({
    children,
    shouldDisplayNotifications,
    shouldDisplayAdvancedDebugInfo,
    shouldDisplayCustomizations,
    ...props
}) => {
    return (
        <Shell isDevEnv={isDev} {...props}>
            <GlobalLiveMessage />
            <ConnectedPageTransition />
            <InnerShell
                shouldDisplayNotifications={shouldDisplayNotifications}
                shouldDisplayAdvancedDebugInfo={shouldDisplayAdvancedDebugInfo}
                shouldDisplayCustomizations={shouldDisplayCustomizations}
            >
                {children}
            </InnerShell>
        </Shell>
    );
};
